import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { SoundConfig } from './SoundConfig';
import { INolimitAudioPlayer } from '@nolimitcity/slot-audio/bin/INolimitAudioPlayer';
import { NolimitHowl } from '@nolimitcity/slot-audio/bin/NolimitHowl';
import { ArrayHelper } from '../../../core/utils/ArrayHelper';

export class SoundManager {
    protected static currentLoop: string[] = [''];
    private static currentBigWin: string = '';

    private static standardVolume = 1;
    private static deadVolume = 0.35;

    private static feelVolume = 0.5;
    private static feelLevel = 0;

    private static tlCounter: gsap.core.Timeline;

    private static randomSoundVal:string = ";"

    private static currentAmbientLoopName: string = '';

    private static PanningForStop: number[] = [-0.25, -0.18, 0.0, 0.18, 0.25];

    public static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    public static ropeCutSoundsAvailable: number[] = [1, 2, 3, 4, 5];
    public static soulWooshSoundsAvailable: number[] = [1, 2, 3];

    private static rand: number[] = [0,1,2,3,4];

    public static playReelStop( reelID: number, aniticipation: boolean = false, isSF:boolean ): void {
        if(!reelID) this.rand = ArrayHelper.shuffle(this.rand);
        
        const randomReelSound = this.rand[reelID];

        const soundName: string = aniticipation
            ? SoundConfig.SCATTER_LAND[reelID]
            : SoundConfig.REELS_DEFAULT_STOP[randomReelSound]; 
        const sound: NolimitHowl | undefined = this.soundPlayer.fetchSoundPlayer(soundName);
        if (sound) sound.player.stereo(this.PanningForStop[reelID]);
        this.soundPlayer.stopTrack(soundName);
        this.soundPlayer.playTrack({ name: soundName,volume: isSF ? 1 : 0.50 });
    }

    public static playRandomFromList(list: string[],once?:boolean):NolimitHowl | undefined {
        this.randomSoundVal = ArrayHelper.getUniqueRandom(list, this.randomSoundVal);

        if(once) this.soundPlayer.stopTrack(this.randomSoundVal);
        this.soundPlayer.playTrack({ name: this.randomSoundVal });
        return this.soundPlayer.fetchSoundPlayer(this.randomSoundVal);
    }

    public static playReelCutAvalanche(reelID: number) {
        const sound: NolimitHowl | undefined = this.playRandomFromList(SoundConfig.REELS_CUT_AVALANCHE)
        if (sound) sound.player.stereo(this.PanningForStop[reelID]);
    }

    public static playSoulWoosh() {
        this.playRandomFromList(SoundConfig.SOUL_WOOSH,true);
    }

    public static playAmbientLoop(name: string): void {
        this.stopAmbientLoop(this.currentAmbientLoopName);
        this.currentAmbientLoopName = name;
        this.soundPlayer.playTrack({ name: name });
    }

    public static stopAmbientLoop(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    // Please NOTE the duration is in millisecond!
    public static fadeAmbienceLoop(volume: number, duration: number): void {
        volume = volume == 0 ? 0.001 : volume;
        this.soundPlayer.fadeTrack({ name: this.currentAmbientLoopName, duration: duration, to: volume });
    }

    public static isLoaded():boolean{
        return !!this.soundPlayer.fetchSoundPlayer("intro");
    }

    public static playIntro(tl:gsap.core.Timeline):void {
        const introSound = this.soundPlayer.playTrack({
            name: "intro",
        })!;
        introSound.config.loop  = false;
        const startPos = introSound.player.seek() as number;
        introSound!.player.once("play", () => {
            introSound?.seek(tl.time() + startPos)
        })
        introSound!.player.once("end", () => {
            introSound!.player.stop();
        })
    }

    public static playSoundEffect(name: string, repeat?: number, volume?: number): NolimitHowl | undefined {
        return this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume !== undefined ? volume : this.standardVolume,
        });
    }

    public static stopSoundEffect(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    public static onFadeSoundEffect(name: string, volume: number, duration: number): void {
        this.soundPlayer.fadeTrack({ name: name, to: volume, duration: duration });
    }

    public static reset(): void {
        SoundManager.playAmbientLoop(SoundConfig.GAME_AMBIANCE);
    }

    public static bonusMusicBigWin(active: boolean): void {
        if (active) SoundManager.fadeAmbienceLoop(1, 1);
        else SoundManager.fadeAmbienceLoop(0, 1);
    }

    public static playRespin(): void {
        SoundManager.playAmbientLoop(SoundConfig.RESPIN_MUSIC);
    }

    public static playBonus(): void {
        SoundManager.playAmbientLoop(SoundConfig.FS_GAME_AMBIANCE);
    }

    private static getFeelVolume(lvl: number): number {
        return 0.5 + lvl * 0.1;
    }

    public static setDeadSpinVolume(val: boolean) {
        this.standardVolume = val ? this.deadVolume : 1;
    }

    public static playScatterLand(lvl: number, dead: boolean): NolimitHowl | undefined {
        SoundConfig.SCATTER_LAND.forEach((soundName: string) => this.soundPlayer.stopTrack(soundName));
        return this.soundPlayer.playTrack({ name: SoundConfig.SCATTER_LAND[lvl], volume: dead ? this.deadVolume : 1 });
    }

    public static startAmbient(): void {
        return;
        this.currentLoop.forEach((loop) => {
            this.soundPlayer.playTrack({ name: loop, volume: 1, repeat: Number.MAX_SAFE_INTEGER });
        });
    }

    public static stopAmbient(): void {
        this.currentLoop.forEach((loop) => {
            this.soundPlayer.stopTrack(loop);
        });
    }

    public static fadeOutAmbient(duration: number = 2000, volume: number = 0): void {
        this.currentLoop.forEach((loop) => {
            this.soundPlayer.fadeTrack({ name: loop, duration: duration, to: volume });
        });
    }

    public static fadeInAmbient(duration: number = 3000, volume: number = 1): void {
        this.currentLoop.forEach((loop) => {
            this.soundPlayer.fadeTrack({
                name: loop,
                duration: duration,
                to: loop === SoundConfig.GAME_AMBIANCE ? this.getFeelVolume(this.feelLevel) : volume,
            });
        });
    }

    public static startNewFsMusic(intro: string, loop: string): void {
        this.ChangeToLoop([loop]);

        const p = this.soundPlayer.playTrack({ name: intro });

        if (!p) {
            this.soundPlayer.stopTrack(intro);
            this.startAmbient();
        } else {
            p.player.loop(false);
            p.player.once('end', () => {
                this.startAmbient();
            });
        }
    }

    public static fadeBigWin(durr: number): void {
        this.feelLevel = 4;
        this.soundPlayer.fadeTrack({ name: this.currentBigWin, from: 1, to: 0, duration: durr });
    }

    public static stopBigWin(): void {
        this.soundPlayer.stopTrack(this.currentBigWin);
        this.currentBigWin = '';
    }

    private static ApplyLoop(loop: string): void {
        if (!this.currentLoop.includes(loop)) this.currentLoop.push(loop);
    }

    public static ChangeToLoop(newLoop: string[]): void {
        this.emptyLoop();
        newLoop.forEach((l) => this.ApplyLoop(l));
    }

    public static emptyLoop(): void {
        this.stopAmbient();
        while (this.currentLoop.length) this.RemoveLoop(this.currentLoop[0]);
    }

    private static RemoveLoop(loop: string): void {
        ArrayHelper.removeFirstMatchElement(this.currentLoop, loop);
    }

    public static StopAllSounds(): void {
        if (this.soundPlayer.allPlayers()[0])
            // Loaded
            this.soundPlayer.allPlayers().forEach((p) => {
                p.stop();
            });
    }

    public static fadeSound(name: string, from: number = 1, to: number, duration: number): void {
        this.soundPlayer.fadeTrack({
            name: name,
            duration: duration,
            from: from,
            to: to,
        });
    }
}
